'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-underscore-dangle */

var jsonpath = require('jsonpath');
var Promise = require('bluebird');
var log = require('loglevel');

var scorekeeperDataSource = require('./ScorekeeperDataSource');

var ENVIRONMENTS = require('./ScorekeeperEnvironments');

var _dataSource = void 0;

function scoreObjectWithInfluencers(obj, influencers) {
    var totalScore = 0;
    var influences = [];

    influencers.forEach(function (influencer) {
        var influencerPaths = influencer.paths;

        influencerPaths.forEach(function (influencerPath) {
            // follow the jsonpath to get the scoreable keys from the object
            // filter those keys down to what exists in the influencer "scores" map
            var values = jsonpath.query(obj, influencerPath).filter(function (value) {
                return influencer.scores && influencer.scores.hasOwnProperty(value);
            });

            // get the score value for each scoreable key and add them up
            var score = values.reduce(function (prev, curr) {
                return prev + influencer.scores[curr] || 0;
            }, 0);

            if (score) {
                influences.push({ name: influencer.name, values: values, score: score });
                totalScore = totalScore + score;
            }
        });
    });

    return [totalScore, influences];
}

// creates the scores table for a given influencer, based on the "scoreContexts"
// (which is an array of fan preferences for v1)
var geval = eval;

function hydrateInfluencersWithScoreContexts(influencers, scoreContexts) {
    return influencers.map(function (infl) {
        var influencer = _extends({}, infl);

        scoreContexts.forEach(function (scoreContext) {
            var scoreKey = jsonpath.value(scoreContext, influencer.keyPath);

            if (scoreKey) {
                (function () {
                    var expressionContext = _extends({}, influencer.context);

                    Object.keys(expressionContext).forEach(function (key) {
                        var val = expressionContext[key];
                        var isPath = (typeof val === 'string' || val instanceof String) && val.indexOf('$.') === 0;

                        if (isPath) {
                            expressionContext[key] = jsonpath.value(scoreContext, val);
                        }
                        geval(key + ' = ' + expressionContext[key]);
                    });
                    var score = geval(influencer.expression);
                    influencer.scores = influencer.scores || {};
                    influencer.scores[scoreKey] = score;
                })();
            }
        });

        return influencer;
    });
}

function getScoredDynamicInfluencers() {
    var scoreContexts = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

    if (scoreContexts.length <= 0) return Promise.resolve([]);

    return _dataSource.getDynamicInfluencers().then(function (infls) {
        return hydrateInfluencersWithScoreContexts(infls, scoreContexts);
    });
}

function getInfluencers() {
    var dynamicScoreContexts = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

    return Promise.all([_dataSource.getBasicInfluencers(), getScoredDynamicInfluencers(dynamicScoreContexts)]).spread(function (basicInfluencers, dynamicInfluencers) {
        return basicInfluencers.concat(dynamicInfluencers);
    });
}

function Scorekeeper() {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {
        environment: ENVIRONMENTS.PRODUCTION,
        dataSource: scorekeeperDataSource(ENVIRONMENTS.PRODUCTION)
    } : arguments[0];

    var _ref$environment = _ref.environment;
    var environment = _ref$environment === undefined ? ENVIRONMENTS.PRODUCTION : _ref$environment;
    var _ref$dataSource = _ref.dataSource;
    var dataSource = _ref$dataSource === undefined ? scorekeeperDataSource(environment) : _ref$dataSource;

    if (!(this instanceof Scorekeeper)) {
        return new Scorekeeper({ dataSource: dataSource });
    }

    _dataSource = dataSource;
    return this;
}

Scorekeeper.Environment = ENVIRONMENTS;

Scorekeeper.prototype.getBasicInfluencers = function () {
    return _dataSource.getBasicInfluencers();
};

Scorekeeper.prototype.getDynamicInfluencers = function () {
    return _dataSource.getDynamicInfluencers();
};

Scorekeeper.prototype.getInfluencers = getInfluencers;

Scorekeeper.prototype.getScoredDynamicInfluencers = getScoredDynamicInfluencers;

Scorekeeper.prototype.scoreObject = function scoreObject(obj) {
    var callback = arguments.length <= 1 || arguments[1] === undefined ? function () {} : arguments[1];
    var dynamicScoreContexts = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

    return getInfluencers(dynamicScoreContexts).then(function (influencers) {
        var _scoreObjectWithInflu = scoreObjectWithInfluencers(obj, influencers);

        var _scoreObjectWithInflu2 = _slicedToArray(_scoreObjectWithInflu, 2);

        var score = _scoreObjectWithInflu2[0];
        var influences = _scoreObjectWithInflu2[1];


        callback(null, { score: score, influences: influences });
        return { score: score, influences: influences };
    }, function (err) {
        return callback(err, null);
    });
};

Scorekeeper.prototype.scoreArray = function scoreArray(objs) {
    var callback = arguments.length <= 1 || arguments[1] === undefined ? function () {} : arguments[1];
    var dynamicScoreContexts = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

    return getInfluencers(dynamicScoreContexts).then(function (influencers) {
        var scores = objs.map(function (obj) {
            var _scoreObjectWithInflu3 = scoreObjectWithInfluencers(obj, influencers);

            var _scoreObjectWithInflu4 = _slicedToArray(_scoreObjectWithInflu3, 2);

            var score = _scoreObjectWithInflu4[0];
            var influences = _scoreObjectWithInflu4[1];

            return { score: score, influences: influences };
        });

        callback(null, scores);
        return scores;
    }, function (err) {
        log.error('scoring error: ' + err);
        callback(err, []);
        return [];
    });
};

module.exports = Scorekeeper;


//////////////////
// WEBPACK FOOTER
// ./~/watch-scorekeeper/dist/Scorekeeper.js
// module id = 815
// module chunks = 0